/*
  c-hero.js
  ------------------------------------------------------------
  Drives the "C Hero Slider" section (sections/c-hero.liquid).
  - Main full-bleed Swiper (autoplay / fade or slide / loop)
  - Nested per-slide product highlighter Swiper (arrows + progressbar)
  - Reveal animations via IntersectionObserver
  - Theme editor support (re-init on section load, slide-to on block select)
  Requires window.Swiper (assets/swiper-bundle.min.js, loaded before this file).
*/
(function () {
  'use strict';

  if (window.__cHeroLoaded) return;
  window.__cHeroLoaded = true;

  function whenSwiperReady(callback) {
    if (typeof window.Swiper !== 'undefined') return callback();
    var tries = 0;
    var timer = setInterval(function () {
      if (typeof window.Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (++tries > 200) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initProductsSliders(root) {
    root.querySelectorAll('.c-hero-products').forEach(function (component) {
      var el = component.querySelector('.c-hero-products__swiper');
      if (!el || el.swiper) return;

      var count = el.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
      var prevEl = component.querySelector('.c-hero-products__arrow--prev');
      var nextEl = component.querySelector('.c-hero-products__arrow--next');
      var progressEl = component.querySelector('.c-hero-products__progress');
      var peek = parseFloat(getComputedStyle(component).getPropertyValue('--c-hero-card-peek')) || 56;

      new window.Swiper(el, {
        nested: true,
        effect: 'creative',
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        loop: component.dataset.loop === 'true' && count > 1,
        watchSlidesProgress: true,
        creativeEffect: {
          limitProgress: 1,
          // Upcoming card waits behind the active one, peeking out
          // to the side; on change it slides out from underneath.
          next: {
            translate: [peek, 0, -70],
            opacity: 0.4,
          },
          // Outgoing card tucks back behind the stack and fades.
          prev: {
            translate: [peek * 0.6, 0, -10],
            opacity: 0.4,
          },
        },
        navigation: prevEl && nextEl ? { prevEl: prevEl, nextEl: nextEl } : false,
        pagination: progressEl ? { el: progressEl, type: 'progressbar' } : false,
      });
    });
  }

  function initHero(root) {
    if (root.dataset.cHeroInitialized === 'true') return;
    root.dataset.cHeroInitialized = 'true';

    var mainEl = root.querySelector('.c-hero__swiper');
    if (!mainEl) return;

    var slideCount = mainEl.querySelectorAll('.swiper-wrapper > .c-hero-slide').length;
    var multipleSlides = slideCount > 1;
    var data = root.dataset;

    var options = {
      effect: data.effect === 'fade' ? 'fade' : 'slide',
      fadeEffect: { crossFade: true },
      speed: parseInt(data.speed, 10) || 800,
      loop: multipleSlides && data.loop === 'true',
      allowTouchMove: multipleSlides,
      autoplay: false,
    };

    if (multipleSlides && data.autoplay === 'true') {
      options.autoplay = {
        delay: parseInt(data.autoplayDelay, 10) || 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: data.pauseHover === 'true',
      };
    }

    var main = new window.Swiper(mainEl, options);
    root.cHeroSwiper = main;

    initProductsSliders(root);

    // Reveal (triggers content + product pop-out animations)
    var reveal = function () {
      root.classList.add('is-revealed');
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal();
              io.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      io.observe(root);
    } else {
      reveal();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.c-hero').forEach(function (root) {
      whenSwiperReady(function () {
        initHero(root);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* ---------- Shopify theme editor ---------- */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest('.c-hero') : null;
    if (!root || !root.cHeroSwiper) return;

    var slide = event.target.closest('.c-hero-slide') || event.target.querySelector('.c-hero-slide');
    if (!slide) return;

    var index = parseInt(slide.dataset.slideIndex, 10);
    if (isNaN(index)) return;

    var swiper = root.cHeroSwiper;
    if (swiper.params.loop) {
      swiper.slideToLoop(index, 400);
    } else {
      swiper.slideTo(index, 400);
    }
    if (swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
  });
})();
